import { useState, useEffect } from 'react';

import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";

import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";
import { assetURL } from "lib/utilities/asset";

const iFramePopup = new Popup({
	title: function() {
		return this.get('title') ?? 'iFrame';
	},
	styleContainer: {padding: 1},
	style: {maxWidth: 'revert', maxHeight: 'revert'},
	render: function() {
		
		const [urlEmbed, setUrlEmbed] = useState<string>(this.get('url'));
			
		useEffect(() => {
			setUrlEmbed(this.get('url'));
		}, [this.get('url')]);
		
		const maxWidth:number = 800;
		const maxHeight:number = 600;
		
		const aspectRatio:number = maxWidth / maxHeight;
		
		const w:number = _dimensions.width > 800 ? (_dimensions.width * 0.6) : (_dimensions.width - 20);
		
		let width:number = w > maxWidth ? maxWidth : w;
		let height:number = width / aspectRatio;
		
		if(height > _dimensions.height - 150)
			height = _dimensions.height - 150;
		
		console.log(urlEmbed);
		
		return (
			<>
				<iframe
					src={urlEmbed}
					width={width}
					height={height}
					style={{border: 0}}
					loading="lazy"
				>
				</iframe>
			</>
		)
	}
});

export default iFramePopup;